import type { ForgotPasswordEmailForm } from '#modules/auth/types';
import type { FormErrors } from '../types/Form';

export function useForgotPassword() {
  const { validations } = useValidation();
  const { form, handleSubmit, getErrors } = useForm<ForgotPasswordEmailForm>({
    form: {
      username: '',
    },
    rules: {
      username: {
        email: validations.email(),
        required: validations.required('Email address'),
      },
    },
  });
  const isForgotPasswordSuccess = ref(false);

  const {
    data,
    error: serverError,
    pending: loadingForgotPassword,
    execute: execForgotPassword,
  } = useSubmit<{}, { data: FormErrors<ForgotPasswordEmailForm> }>();

  const handleForgotPassword = async (cb?: () => void): Promise<void> => {
    handleSubmit(async () => {
      await execForgotPassword('/auth/forgot-password', {
        method: 'POST',
        body: form.value,
      });

      if (!serverError.value) {
        isForgotPasswordSuccess.value = true;
        cb && cb();
      }
    });
  };

  return {
    form,
    data,
    serverError,
    loadingForgotPassword,
    isForgotPasswordSuccess,
    handleForgotPassword,
    getErrors,
  };
}
